import { forwardRef } from 'react';

import { Alert } from 'reactstrap';

import { useUniqueKey } from '@hsp/react-hooks';

import { AlertProps } from 'types/components/alerts';

const Errors = forwardRef<HTMLDivElement, Pick<AlertProps, 'children' | 'error'>>(({ children, error }, ref) => {
  const { errors } = error ?? { errors: [] };
  const uniqueKey = useUniqueKey();

  return (
    <Alert
      color="danger"
      innerRef={ref}>
      {errors.map((error) => (
        <div key={uniqueKey(error)}>{error.details}</div>
      ))}
      {children}
    </Alert>
  );
});

Errors.displayName = 'Errors';

export default Errors;
